// Which site this build of the EduSense SPA serves. app.ugot.uk is the full
// product; learn.ugot.uk (VITE_EDUSENSE_SURFACE=learn) is the course-only site
// served by course-server.
export function edusenseSurface() {
    // Read the one variable by its full name so Vite substitutes just this value;
    // touching import.meta.env as an object makes Vite inline every VITE_* entry.
    // Outside Vite (node tests) import.meta.env does not exist.
    var surface;
    try {
        surface = import.meta.env.VITE_EDUSENSE_SURFACE;
    } catch (e) {
        surface = undefined;
    }
    return surface === 'learn' ? 'learn' : 'app';
}
export var isLearnSurface = function() {
    return edusenseSurface() === 'learn';
};
